document.addEventListener('DOMContentLoaded', function () {
    const page_url = new URL(window.location);
    console.log("page_url", page_url);
    if (page_url.pathname === '/account') {
        if (page_url.searchParams.get('view') === "view") {
            const item_account_info = document.getElementById("item_account_info")
            item_account_info && item_account_info.classList.add("active");
        } else {
            const item_order = document.getElementById("item_order");
            item_order && item_order.classList.add("active");
        }
    }

    const item_account_info = document.getElementById("item_account_info");
    item_account_info && item_account_info.addEventListener("click", function (event) {
        event.preventDefault();
        const activeItem = document.querySelector(".account-menu__item.active");
        activeItem && activeItem.classList.remove("active");
        event.currentTarget.classList.add("active");
        const url = new URL(window.location);
        if (url.pathname == "/account") {
            url.searchParams.set('view', 'view'); // 添加或更新参数
            history.pushState({}, '', url); // 更改地址栏不刷新页面
            document.querySelector(".AccountEditMain").classList.remove('hidden-js');
            document.querySelector(".account__content").classList.add('hidden-js');
        } else {
            location.href="/account?view=view";
        }
    });

    const item_order = document.getElementById("item_order");
    item_order && item_order.addEventListener("click", function (event) {
        console.log("click");
        event.preventDefault();
        const activeItem = document.querySelector(".account-menu__item.active");
        activeItem && activeItem.classList.remove("active");
        event.currentTarget.classList.add("active");
        const url = new URL(window.location);
        if (url.pathname == "/account") {
            url.searchParams.delete('view'); // 删除参数
            history.pushState({}, '', url); // 更改地址栏不刷新页面
            document.querySelector(".AccountEditMain").classList.add('hidden-js');
            document.querySelector(".account__content").classList.remove('hidden-js');
        } else {
            location.href="/account";
        }
    });

    document.querySelector(".account__dropdown-wrapper").addEventListener("click", function(event) {
        if (event.target.matches("#dropdown__item_account_info") || event.target.parentElement.matches("#dropdown__item_account_info")) {
            const url = new URL(window.location);
            if (url.pathname == "/account") {
                url.searchParams.set('view', 'view'); // 添加或更新参数
                history.pushState({}, '', url); // 更改地址栏不刷新页面
                document.querySelector(".dropdown__toggle-label").innerHTML = '<svg class="dropdown__icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-labelledby="title" role="img"> <title id="title">Account</title>          <circle cx="12" cy="7" r="4.5" stroke-width="1.5" stroke="currentColor"></circle>          <path stroke-width="1.5" d="M3.36262 18.1731C3.96938 15.4427 6.39115 13.5 9.18819 13.5H14.8118C17.6089 13.5 20.0306 15.4427 20.6374 18.1731C21.0168 19.8804 19.7176 21.5 17.9686 21.5H6.03136C4.28239 21.5 2.98321 19.8804 3.36262 18.1731Z" stroke="currentColor"></path>        </svg>Account information';
                document.querySelector(".dropdown__toggle").click();
                document.querySelector(".AccountEditMain").classList.remove('hidden-js');
                document.querySelector(".account__content").classList.add('hidden-js');
            } else {
                location.href="/account?view=view";
            }
        }

        if (event.target.matches("#dropdown__item_order") || event.target.parentElement.matches("#dropdown__item_order")) {
            const url = new URL(window.location);
            if (url.pathname == "/account") {
                url.searchParams.delete('view'); // 删除参数
                history.pushState({}, '', url); // 更改地址栏不刷新页面
                document.querySelector(".dropdown__toggle-label").innerHTML = '<svg class="dropdown__icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-labelledby="title" role="img"> <title id="title">Order</title>        <path d="M19 11H5M19 11C20.1046 11 21 11.8954 21 13V19C21 20.1046 20.1046 21 19 21H5C3.89543 21 3 20.1046 3 19V13C3 11.8954 3.89543 11 5 11M19 11V9C19 7.89543 18.1046 7 17 7M5 11V9C5 7.89543 5.89543 7 7 7M7 7V5C7 3.89543 7.89543 3 9 3H15C16.1046 3 17 3.89543 17 5V7M7 7H17" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>      </svg>Order history';
                document.querySelector(".dropdown__toggle").click();
                document.querySelector(".AccountEditMain").classList.add('hidden-js');
                document.querySelector(".account__content").classList.remove('hidden-js');
            } else {
                location.href="/account";
            }
        }
    });
});